import { NodeJsAuthentication } from "@app/shared/models/authentication.model";
import { PdfMessage } from "@app/shared/models/message.model";
import { InputSettings, NotificationSettings, TooltipSettings } from "@app/shared/models/portal-settings.model";
import { LocaleSettings } from "@app/shared/models/system-settings.model";
import { InBasketSettings, ThemeSettings, ViewerSettings } from "@app/shared/models/user-settings.model";

export const ExternalWindowSource: string = "ussi-portal";

export enum ExternalWindowEventTypes {
  Init,
  WindowLoaded,
  OpenWindow,
  ReturnWindow,
  CloseWindow,
  Attach,
  InBasketRead,
  OpenNextDocument,
  GetBase64Document,
  GetDocumentsPlusDocument,
  GetDocumentWizardDocument,
  GetMyReportsDocument,
  StoreTabDocument,
  StoreWindowDocument,
  CheckDirty,
  FormStatus,
  Loading,
  Notification,
  Hidden,
  Print,
  ToggleTheme,
  EndOfFileReached
}

export interface ExternalWindowParms {
  title: string;
  sessionNumber: number;
  source: string; // Should be 'ussi-portal';
  event: number; // ExternalWindowEventTypes
  serverUrl: string; // env server url
  origin: string; // window origin
  applicationId: string;
  credentials: ExternalWindowCredentials;
  toggleSettings: ExternalWindowToggleSettings;
  localeSettings: LocaleSettings;
  themeSettings: ThemeSettings;
  viewerSettings: ViewerSettings;
  inputSettings: InputSettings;
  inbasketSettings: InBasketSettings;
  notificationSettings: NotificationSettings;
  tooltipSettings: TooltipSettings;
  data: PdfMessage;
}

export interface ExternalWindowEvent {
  source: string; // should be ussi-portal
  origin: string;
  event: number; // ExternalWindowEventTypes
  data: any;
}

export interface ExternalWindowCredentials {
  username: string;
  displayName: string;
  token: string;
  nodeJsAuthentication: NodeJsAuthentication;
}

export interface ExternalWindowToggleSettings {
  showOpen: boolean;
  showReturn: boolean;
}
